import axios from 'axios'
import {
  getApiUrl,
  hasPandora,
  getValueFormatted,
  getApiSeoUrl,
  getApiSeoCertName,
} from '../utils/utils'
import { FETCH_DETAIL, FETCH_DETAIL_FAILURE, createUrl } from './detail'
import { FETCH_CATEGORIES_SUCCESS } from './categories'
import { FETCH_AVERAGEPRICE } from './averagePrice'
import { FETCH_SEO_DIRECTIVES } from './seoDirectives'

let httpAgent
let httpsAgent
let seoHttpsAgent
if (typeof window === 'undefined') {
  // eslint-disable-next-line
  const http = require(/* webpackIgnore: true */ 'http')
  // eslint-disable-next-line
  const https = require(/* webpackIgnore: true */ 'https')
  // eslint-disable-next-line
  const tls = require(/* webpackIgnore: true */ 'tls')
  httpAgent = new http.Agent({ keepAlive: true })
  httpsAgent = new https.Agent({ keepAlive: true })

  const seoCertName = getApiSeoCertName()
  seoHttpsAgent = new https.Agent({
    keepAlive: true,
    checkServerIdentity: seoCertName
      ? (host, cert) => {
          const hostErr = tls.checkServerIdentity(host, cert)
          return hostErr
            ? tls.checkServerIdentity(seoCertName, cert)
            : undefined
        }
      : undefined,
  })
}

/**
 * Thunk único para SSR que busca detail, categories e averagePrice
 * em uma única promise chain. Evita despachar múltiplos thunks que
 * causam colisão de hash no redux-universal.
 */
export function fetchAdDetailSSR(detailData, vehicleType) {
  const detailUrl = createUrl(detailData)
  const pandora = hasPandora()

  const SSR_TIMEOUT = 8000

  const axiosOpts = {
    params: { pandora },
    timeout: SSR_TIMEOUT,
    httpAgent,
    httpsAgent,
  }

  return dispatch => {
    return axios
      .get(detailUrl, axiosOpts)
      .then(detailRes => {
        dispatch({
          type: FETCH_DETAIL,
          payload: detailRes.data,
          requested: detailData,
        })

        const formattedId = getValueFormatted(detailRes.data.UniqueId)
        const catUrl = `${getApiUrl()}category`
        const avgUrl = `${getApiUrl()}detail/averageprice/${vehicleType}/${formattedId}`

        const apiSeoUrl = getApiSeoUrl()
        const seoDirectivesUrl =
          apiSeoUrl &&
          `${apiSeoUrl}anuncios/${detailRes.data.UniqueId}/seo-directives`
        const tipoVeiculo = vehicleType === 'bike' ? 'moto' : 'carro'
        const seoDirectivesOpts = {
          ...axiosOpts,
          params: { tipoVeiculo },
          httpsAgent: seoHttpsAgent,
        }

        const seoDirectivesPromise = seoDirectivesUrl
          ? axios
              .get(seoDirectivesUrl, seoDirectivesOpts)
              .then(res =>
                dispatch({ type: FETCH_SEO_DIRECTIVES, payload: res.data })
              )
              .catch(err => {
                console.error(
                  '[SSR] seo-directives falhou:',
                  seoDirectivesUrl,
                  err?.code || err?.message || err
                )
              })
          : Promise.resolve(
              dispatch({
                type: FETCH_SEO_DIRECTIVES,
                payload: {
                  anuncioId: detailRes.data.UniqueId,
                  robots: 'noindex,nofollow',
                },
              })
            )

        return Promise.allSettled([
          axios
            .get(catUrl, axiosOpts)
            .then(res =>
              dispatch({ type: FETCH_CATEGORIES_SUCCESS, payload: res.data })
            )
            .catch(() => {}),
          axios
            .get(avgUrl, axiosOpts)
            .then(res =>
              dispatch({ type: FETCH_AVERAGEPRICE, payload: res.data })
            )
            .catch(() => {}),
          seoDirectivesPromise,
        ])
      })
      .catch(err => {
        dispatch({
          type: FETCH_DETAIL_FAILURE,
          payload: err.stack,
          errorStatus: err.response?.status || null,
          requested: detailData,
          statusCode: err.response ? err.response.status : null,
        })
      })
  }
}
